import { ampli } from '@/ampli';

/**
 * Retour des méthodes générées par Ampli : un `PromiseResult`, dont le rejet
 * doit être absorbé (cf. `AmplitudeTracking`) pour ne jamais produire
 * d'unhandled rejection.
 */
type AmpliCallResult = { promise?: Promise<unknown> } | void | undefined;

/**
 * Émet un event Amplitude sans jamais pouvoir casser la page appelante.
 *
 * Trois protections, dans cet ordre :
 *   - `ampli.isLoaded` — le SDK n'est initialisé qu'en production
 *     (`resolveAmplitudeApiKey` renvoie `null` en local et en recette), donc
 *     hors production l'appel est un no-op silencieux ;
 *   - `try/catch` pour la partie synchrone ;
 *   - `.promise.catch()` pour le rejet asynchrone du SDK.
 *
 * Le tracking est une préoccupation secondaire : une erreur ici se log, elle
 * ne remonte jamais à l'utilisateur.
 */
export function trackEvent(emit: () => AmpliCallResult): void {
    if (!ampli.isLoaded) return;

    try {
        emit()?.promise?.catch(() => {});
    } catch (error) {
        console.error('Amplitude track failed', error);
    }
}
